import React from "react";

/** Custom warning-triangle logo with a running stick figure inside.
 *  Triangle frame is yellow (Dash), stick figure is red (Smash). */
function WarningRunnerIcon({ size = 28, className = "" }) {
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            aria-hidden="true"
        >
            {/* Yellow triangle outline */}
            <path
                d="M32 5 L61 57 L3 57 Z"
                stroke="#FFCC00"
                strokeWidth="5"
                strokeLinejoin="miter"
                fill="none"
            />
            {/* Red running stick figure - bigger and more visible */}
            <g stroke="#FF003C" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none">
                {/* head */}
                <circle cx="38" cy="22" r="4" fill="#FF003C" stroke="none" />
                {/* torso (leaning forward) */}
                <path d="M37 27 L30 42" />
                {/* front arm swinging forward */}
                <path d="M33 32 L24 28" />
                {/* back arm swinging back */}
                <path d="M35 33 L44 38" />
                {/* front leg kicked forward */}
                <path d="M30 42 L38 52" />
                {/* back leg pushing off */}
                <path d="M30 42 L21 50" />
            </g>
        </svg>
    );
}

export function Logo({ size = "md", className = "" }) {
    const sizes = {
        sm: { text: "text-xl", icon: 22, gap: "gap-1" },
        md: { text: "text-3xl", icon: 30, gap: "gap-1.5" },
        lg: { text: "text-5xl", icon: 44, gap: "gap-2" },
        xl: { text: "text-6xl sm:text-7xl", icon: 64, gap: "gap-3" },
    };
    const s = sizes[size] || sizes.md;
    return (
        <div
            className={`font-display flex items-end ${s.gap} ${s.text} leading-none select-none ${className}`}
            data-testid="app-logo"
        >
            <span className="text-smash tracking-wide">SMASH</span>
            <span className="text-white opacity-50 mx-0.5 self-center">&</span>
            <span className="text-dash tracking-wide flex items-end">
                DASH
                <WarningRunnerIcon size={s.icon} className="ml-1 -mb-0.5" />
            </span>
        </div>
    );
}

export default Logo;
